import { REFERENCE_RECORD } from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/formatter/FormatTypes';
import { CustomObjectTypeIdRegex, StandardObjectTypeIdRegex } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import { hasAssociatedObjectsUsingFrameworkAppSettings } from '../../../permissions/gates';
import { toDSFieldRecord } from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/toDSFieldRecord';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
import PortalIdParser from 'PortalIdParser';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import formatProperties from 'reference-resolvers/formatters/formatProperties';
export class ObjectPropertiesAdapterConfig extends HttpAdapterConfig {
  constructor(...args) {
    super(...args);
    this.performanceTrackingKey = 'ObjectPropertiesAdapter';
  }
  getCacheKey(assetFamily) {
    return `OBJECT_PROPERTIES_${assetFamily}`;
  }
  isAssetFamilySupported(assetFamily) {
    if (hasAssociatedObjectsUsingFrameworkAppSettings()) {
      return StandardObjectTypeIdRegex.test(assetFamily) || CustomObjectTypeIdRegex.test(assetFamily);
    }
    return CustomObjectTypeIdRegex.test(assetFamily);
  }
  fetchData(httpClient, assetFamily) {
    const options = {
      query: {
        portalId: PortalIdParser.get(),
        includeFieldLevelPermission: true,
        includeProperties: true
      },
      timeout: 60000
    };
    return httpClient(`properties/v4/groups/${assetFamily}`, options);
  }
  formatData(response, assetFamily) {
    const formattedProperties = formatProperties(response.results);
    return toDSFieldRecord(formattedProperties, assetFamily, REFERENCE_RECORD);
  }
}
export default Adapter.makeFromConfig(ObjectPropertiesAdapterConfig);